function hashCode(string) {
    var hash = 0;
    for (var i = 0; i < string.length; i++) {
        var code = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + code;
        hash = hash & hash; // Convert to 32bit integer
        hash = Math.abs(hash);
    }
    return hash;
}

const icon = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard" viewBox="0 0 16 16">' +
    '<path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>' +
    '<path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/></svg>'

window.copyToClipboard = (btnId, divId) => {
    var node = document.getElementById(divId).parentNode;
    var textContent = node.textContent.trim();

    navigator.clipboard.writeText(textContent).then(function () {
        /* clipboard successfully set */
        const element = document.getElementById(btnId);
        element.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
            </svg>`;

    }, function () {
        /* clipboard write failed */
    });
};

window.outFunc = (btnId) => {
    const element = document.getElementById(btnId);
    element.innerHTML = icon;
};

const button = (btnId, divId) => {
    return `<button type="button" class="btn btn-sm btn-outline-primary" id="${btnId}"
    onclick="copyToClipboard('${btnId}', '${divId}')" 
    onfocusout="outFunc('${btnId}')"   
    >${icon}</button>`
}

module.exports = (md) => {
    let id = hashCode(md);
    let btnId = "btn-" + id;
    let divId = "div-" + id;

    return `<div class="float-right position-relative" id="${divId}" >` + button(btnId, divId) + `</div>`;
};